module.exports = __webpack_public_path__ + "img/desc_bottom_cj9100.2723dde9.png";